(() => {
  'use strict';
  if (window.__AQ_V4_PAGE_SKIN__) return;
  window.__AQ_V4_PAGE_SKIN__ = true;

  const path = location.pathname;
  const body = document.body;
  const add = (name) => body.classList.add(name);

  if (document.querySelector('.section-aquaphoria-collection-v3')) add('aq-v4-page-collection');
  if (document.querySelector('[data-testid="product-information"], .product-information')) add('aq-v4-page-product');
  if (path.startsWith('/pages/aquapedia')) add('aq-v4-page-aquapedia');
  if (path.startsWith('/search')) add('aq-v4-page-search');
  if (path === '/cart') add('aq-v4-page-cart');
  if (path === '/collections') add('aq-v4-page-collections-index');
  if (path.startsWith('/policies/')) add('aq-v4-page-policy');
  if (path.startsWith('/blogs/')) add('aq-v4-page-blog');
  if (path.startsWith('/pages/') && !path.startsWith('/pages/aquapedia')) add('aq-v4-page-standard');
  if (path === '/pages/shipping-doa-policy') add('aq-v4-page-shipping');
  if (path === '/pages/contact') add('aq-v4-page-contact');
  if (path === '/pages/aquarium-experience') add('aq-v4-page-experience');
  if (path.startsWith('/blogs/')) add('aq-v4-page-news');

  if (path === '/pages/contact') {
    const contactForm = document.querySelector('.contact-form');
    if (contactForm) contactForm.id = 'aquaphoria-contact-form';
  }

  if (path === '/pages/contact' || path === '/pages/shipping-doa-policy') {
    const hiddenPageHeading = document.querySelector('.aq-service-hero-v5 + .shopify-section.section-wrapper .section-content-wrapper > .text-block:first-child h1');
    if (hiddenPageHeading) {
      const replacement = document.createElement('h2');
      for (const attr of hiddenPageHeading.attributes) replacement.setAttribute(attr.name, attr.value);
      replacement.innerHTML = hiddenPageHeading.innerHTML;
      hiddenPageHeading.replaceWith(replacement);
    }
  }

  if (path === '/pages/shipping-doa-policy') {
    const policyBody = document.querySelector('main .rte');
    if (policyBody) {
      policyBody.id = 'aq-policy-body';
      const slugify = (value) => value.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
      policyBody.querySelectorAll('h2').forEach((heading) => {
        if (!heading.id) heading.id = 'aq-policy-' + slugify(heading.textContent || 'section');
      });
    }
  }

  const observed = ['aq-v4-page-collection','aq-v4-page-product','aq-v4-page-aquapedia','aq-v4-page-search','aq-v4-page-cart'];
  if (observed.some((c) => body.classList.contains(c))) add('aq-v4-page-aquatic');
})();
